//
//
//
//
//
//
//
//
//
//

import { chunk } from '../utils/shared';
import { defineComponent } from '../utils/create';
import { props } from './props';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "waterfall-container"
  }, _vm._l(_vm.renderList, function (row, rowIdx) {
    return _c('div', {
      key: rowIdx,
      staticClass: "waterfall-row"
    }, _vm._l(row, function (col, colIdx) {
      return _c('div', {
        key: rowIdx + ':' + colIdx,
        staticClass: "waterfall-col"
      }, [_vm._t("default", null, {
        "item": col,
        "row": row
      })], 2);
    }), 0);
  }), 0);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-56fe9a7f',
  render,
  name: 'CbWaterfall',
  props,
  computed: {
    renderList() {
      return chunk(this.list, this.sizeOfRow);
    }
  }
});